export enum COUNTRY {
  AUSTRALIA = 'Australia',
  CANADA = 'Canada',
  FRANCE = 'France',
  GERMANY = 'Germany',
  IRELAND = 'Ireland',
  SWITZERLAND = 'Switzerland',
  UK = 'United Kingdom',
  USA = 'United States of America'
}

export const COUNTRY_ALT_NAME = {
  GERMANY: ['Deutschland'],
  IRELAND: ['Éire'],
  SWITZERLAND: ['Schweiz', 'Suisse', 'Svizzera', 'Svizra'],
  UK: [
    'Great Britain',
    'Britain',
    'England',
    'Scotland',
    'Wales',
    'Northern Ireland',
    'Y Deyrnas Unedig',
    'Unitit Kinrick',
    'Ríocht Aontaithe'
  ],
  USA: [
    'United States',
    'US',
    'U.S.',
    'U.S.A.',
    'America',
    'Estados Unidos',
    'États-Unis'
  ]
}
